// "Complete Your Build" post-checkout upsell — curated, hand-picked cross-sell items
// (not fabricated: every product/price/thumb below matches its real entry in the
// corresponding category data file). Keyed by the purchased product's category
// (the first URL segment of product_path returned by /api/checkout/status).

const LOAD_BARS = {
  name: "K9 Load Bar Kits",
  price: 795,
  priceFrom: true,
  thumb: "/products/roofracks/731077_81defb997f55450bb063b05fe1ccca72~mv2.jpg",
  to: "/roof-racks/k9-load-bar-kits",
};
const AWNING = {
  name: "Quick Pitch Weathershade MAXX",
  price: 2795,
  thumb: "/products/awnings/731077_783d72174df043d28d6bba803b70ab82~mv2.jpg",
  to: "/awnings/quick-pitch-weathershade-maxx",
};
const FRIDGE = {
  name: "National Luna 35 Litre Fridge/Freezer",
  price: 1569,
  priceFrom: true,
  thumb: "/products/fridges/731077_d14c8e280ba44f74bae9736abe108af2~mv2.jpg",
  to: "/12v-fridges/national-luna-35l",
};
const MINI_KITCHEN = {
  name: "Quick Pitch Complete Mini Kitchen",
  price: 3499,
  thumb: "/products/drawers/731077_c751d09447894393a61cd25c8a2bfe7b~mv2.jpg",
  to: "/drawers-kitchens-tables/quick-pitch-complete-mini-kitchen",
};
const K9_CHAIR = {
  name: "EEZI-AWN K9 Chair",
  price: 239,
  thumb: "/products/jimny/731077_af2e997e6f8b4ebfbc228cd555bb7348~mv2.jpg",
  to: "/camping-accessories/eezi-awn-k9-chair",
};
const SAFARI_CHEF = {
  name: "CADAC Safari Chef 30",
  price: 339,
  thumb: "/products/cooking/731077_1407f5348496436ebbdce0193755a553~mv2.jpg",
  to: "/camp-cooking/cadac-safari-chef-30",
};
const ENSUITE_BAG = {
  name: "Quick Pitch Quick Ensuite — Bag Unit",
  price: 599,
  thumb: "/products/ensuites/731077_a360f6691759495e94ee4e4214788831~mv2.jpg",
  to: "/ensuites/quick-pitch-quick-ensuite-bag",
};
const ENSUITE_BOX = {
  name: "Quick Pitch Quick Ensuite — Box Unit",
  price: 899,
  thumb: "/products/ensuites/731077_d4cc6964c015438ca2361aa14cff6347~mv2.jpg",
  to: "/ensuites/quick-pitch-quick-ensuite-box-unit",
};
const CHARCOAL_BAG = {
  name: "Canvas Charcoal Storage Bag",
  price: 44.95,
  thumb: "/products/camping-accessories/731077_e61fd917f2e648ff90da7a71367469d6~mv2.webp",
  to: "/camping-accessories/canvas-charcoal-storage-bag",
};

const DEFAULT_UPSELL = [LOAD_BARS, AWNING, FRIDGE];

export const UPSELL_MAP = {
  "wellside-canopies": [LOAD_BARS, AWNING, MINI_KITCHEN, FRIDGE],
  "wellside-accessories": [LOAD_BARS, AWNING, FRIDGE],
  "x-series-tray": [LOAD_BARS, AWNING, MINI_KITCHEN, FRIDGE],
  "roof-racks": [AWNING, FRIDGE, MINI_KITCHEN],
  "roof-tents": [ENSUITE_BOX, AWNING, FRIDGE],
  "ground-tents": [SAFARI_CHEF, K9_CHAIR, CHARCOAL_BAG],
  awnings: [ENSUITE_BAG, LOAD_BARS, SAFARI_CHEF],
  "12v-fridges": [MINI_KITCHEN, LOAD_BARS, K9_CHAIR],
  "drawers-kitchens-tables": [FRIDGE, SAFARI_CHEF, K9_CHAIR],
  "camp-cooking": [K9_CHAIR, CHARCOAL_BAG, FRIDGE],
  "camping-accessories": [SAFARI_CHEF, FRIDGE, MINI_KITCHEN],
  ensuites: [AWNING, LOAD_BARS, FRIDGE],
  "bull-bars": [LOAD_BARS, K9_CHAIR, SAFARI_CHEF],
  "bush-cabin": [FRIDGE, MINI_KITCHEN, SAFARI_CHEF],
  "jimny-store": DEFAULT_UPSELL,
  clearance: DEFAULT_UPSELL,
};

export function getUpsellItems(productPath) {
  if (!productPath) return DEFAULT_UPSELL;
  const category = productPath.split("/").filter(Boolean)[0];
  return UPSELL_MAP[category] || DEFAULT_UPSELL;
}
